define('lib/queryStringObj',[], function () {
  return function queryStringToObj(queryString) {
    var params = {}; var queries; var temp; var i; var l;
    // Split into key/value pairs
    queries = queryString.split('&');
    // Convert the array of strings into an object
    for (i = 0, l = queries.length; i < l; i += 1) {
      temp = queries[i].split('=');
      // params[temp[0]] = temp[1];
      if (params[temp[0]]) {
        if (params[temp[0]] != temp[1]) {
          if (!Array.isArray(params[temp[0]])) {
            var arr = [];
            arr.push(params[temp[0]]);
            params[temp[0]] = arr;
          }
          params[temp[0]].push(temp[1]);
        }
      } else params[temp[0]] = temp[1];
    }
    return params;
  };
});

